<template>
  <div class="col-md-12 server_group">
    <div class="server_group_header">
      <button type="button" class="btn btn-success" @click="addNew">
        <i class="mdi mdi-plus-circle-outline" />{{ translate('group.create') }}
      </button>
    </div>
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th
                scope="col"
                class="text-left pointer"
                :class="{ selected: filter_type === 'name' }"
                tabindex="0"
                :aria-sort="filter_type === 'name' ? (filter_asc === 'desc' ? 'ascending' : 'descending') : 'none'"
                @click="change_filter('name')"
                @keydown.enter="change_filter('name')"
                @keydown.space.prevent="change_filter('name')"
            >
              {{ translate('server.instance_group.name') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>
            <th
                scope="col"
                class="pointer w15per"
                :class="{ selected: filter_type === 'servers_count' }"
                tabindex="0"
                :aria-sort="filter_type === 'servers_count' ? (filter_asc === 'desc' ? 'ascending' : 'descending') : 'none'"
                @click="change_filter('servers_count')"
                @keydown.enter="change_filter('servers_count')"
                @keydown.space.prevent="change_filter('servers_count')"
            >
              {{ translate('server.servers_count') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>
            <th scope="col" class="w100"></th>
          </tr>
        </thead>
        <tbody>
          <server-group-item
              v-for="item in sorted_groups"
              :key="item.id"
              :group="item"
              @edit_group="edit_group(item)"
              @del_group="delete_group"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import ServerGroupItem from './Item/Index.vue'
import EditGroup from './Modal/EditGroup.vue'

export default {
  name: 'ServerGroup',
  components: {
    ServerGroupItem
  },
  props: {
    groups_servers: Array
  },
  data () {
    return {
      filter_type: 'name',
      filter_asc: 'desc'
    }
  },
  computed: {
    sorted_groups () {
      let groups = [...(this.groups_servers || [])]
      return groups.sort(this.compareNumbers)
    }
  },
  methods: {
    addNew () {
      const date = new Date()
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      this.edit_group({name: `New Server Group ${day}-${month}-${date.getFullYear()}`})
    },
    edit_group (group) {
      let t = this.$createElement(EditGroup, {
        props: { group },
        on: {
          close: () => {
            this.$modal.hide('edit_server_group')
          },
          update: () => {
            this.$modal.hide('edit_server_group')
            this.$emit('update_servers_group')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', width: 400, adaptive: true, clickToClose: false, scrollable: true, name: 'edit_server_group'})
    },
    delete_group (id) {
      this.$http.v1.deleteServerGroup(id, () => {
        this.global_notify('info', this.translate('server.delete.group_deleted'))
        this.$emit('update_servers_group')
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.server_group{
  padding-top: 30px;
  &_header{
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    .btn{
      padding: 2px 10px;
    }
  }
  .response_table{
    padding: 0;
    ::v-deep .text-left{
      text-align: left;
    }
  }
}
</style>
